import actions from "actions";
import ActionTypes from "actions/ActionTypes";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createLoadingSelector } from "reducers/selectors";
import { bindActionCreators, Dispatch } from "redux";
import "../styles/sidebar.scss";
import { SideBarStoreManagerProps } from "../type";
import SidebarItem from "./SidebarItem";
import { useHistory, useLocation } from "react-router-dom";
import { StoreStatistic } from "Models/store";

const loadingSelector = createLoadingSelector([
  ActionTypes.STORE_STATISTIC_PREFIX,
]);

const initialStatistic: any = 0;

const SideBarStoreManager = ({
  getStoreStatistic,
  storeStatistic = [],
  loading,
}: SideBarStoreManagerProps) => {
  const history = useHistory();
  const location = useLocation();
  const [currentStatistic, setCurrentStatistic] = useState(initialStatistic);
  useEffect(() => {
    getStoreStatistic && getStoreStatistic();
  }, []);
  useEffect(() => {
    setCurrentStatistic(location.search.split("=")?.[1]);
  }, [location]);
  const renderStatisticItem = (item: StoreStatistic) => {
    const handleClick = () => {
      history.push(`/store?status=${item.id}`);
    };
    return (
      <SidebarItem
        isSelected={currentStatistic == item.id}
        key={item.id}
        item={item}
        onClick={handleClick}
      />
    );
  };
  return (
    <div className="side-bar-site">
      {storeStatistic?.map(renderStatisticItem)}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    loading: loadingSelector(state),
    storeStatistic: state.store.storeStatistic,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(SideBarStoreManager);
